<template>
  <div>
    <v-navigation-drawer temporary v-model="sideNav" width="230">
      <v-list>
        <v-list-item
          v-for="items in menuItem"
          :key="items.chave"
          :to="items.link"
          @click="verClick(items.chave)"
          exact
          :prepend-icon="items.icon"
          :title="items.title"
        >
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar color="primary">
      <v-app-bar-title>
        <span style="cursor:pointer">
          <img
            :src="logo"
            @click="$router.currentRoute.value.path.includes('jogo')? $router.go(-1) : $router.push('/')"
            class="logo"
          />
        </span>
      </v-app-bar-title>
      <v-spacer></v-spacer>
      <!-- `pe-2`: sem padding à direita o último botão encosta na borda da
           janela e aparece cortado — visível na tela de login, onde o botão
           ativo tem fundo. -->
      <div class="d-md-none pe-2">
        <v-btn
          variant="text"
          icon
          v-for="items in menuItem"
          :key="'mobile-'+items.chave"
          :to="items.link"
          exact
          @click="verClick(items.chave)"
        >
          <v-icon>{{items.icon}}</v-icon>
        </v-btn>
      </div>
      <div class="d-none d-md-flex align-center pe-3">
        <change-language></change-language>
        <v-btn
          variant="text"
          v-for="items in menuItem"
          :key="'desktop-'+items.chave"
          :to="items.link"
          exact
          @click="verClick(items.chave)"
        >
          <v-icon start>{{items.icon}}</v-icon>
          {{items.title}}
        </v-btn>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import logoFootie from "../../assets/logoFootie.png";
import { mapActions } from "vuex";
import { mapState } from "vuex";
import ChangeLanguage from "./change_language";
import { useAuth } from "@/plugins/vue-auth";

export default {
  components: {
    ChangeLanguage
  },
  setup() {
    const auth = useAuth();
    return { auth };
  },
  data() {
    return {
      sideNav: false,
      e1: 0,
      logo: logoFootie
    };
  },

  methods: {
    // Recebe a CHAVE do item, nao o rotulo. Comparar com o texto traduzido
    // ("Perfil", $t("logout")) faz o menu parar de funcionar assim que o
    // idioma muda: em ingles o rotulo vira "Logout" e nenhum ramo casa.
    verClick(chave) {
      if (chave == "profile" && this.auth?.check()) {
        // Show user profile
      }
      if (chave == "logout" && this.auth?.logout) {
        this.auth.logout();
        this.$router.push("/login");
      }
    },
    ...mapActions({
      showOneQuestion: "Questions/showOneQuestion",
      showOneUser: "Users/showOneUser"
    })
  },
  computed: {
    isAuthenticated() {
      return this.auth?.check() ?? false;
    },
    menuItem() {
      if (this.isAuthenticated) {
        return [
          {
            icon: "mdi-trophy",
            chave: "championships",
            title: this.$t("championships"),
            link: "/campeonatos"
          },
          {
            icon: "mdi-plus-circle",
            chave: "create_championship",
            title: this.$t("create_championship"),
            link: "/campeonatos/novo"
          },
          {
            icon: "mdi-shield-search",
            chave: "teams",
            title: this.$t("teams"),
            link: "/times"
          },
          {
            icon: "mdi-logout",
            chave: "logout",
            title: this.$t("logout"),
            link: "/logout"
          }
        ];
      } else {
        return [
          {
            icon: "mdi-trophy",
            chave: "championships",
            title: this.$t("championships"),
            link: "/campeonatos"
          },
          {
            icon: "mdi-shield-search",
            chave: "teams",
            title: this.$t("teams"),
            link: "/times"
          },
          { icon: "mdi-login", chave: "login", title: this.$t("login"), link: "/login" }
        ];
      }
    },
    change_language() {}
  }
};
</script>

<style scoped>
.logo {
  width: 80px !important;
  height: auto;
  margin-top: 10px;
}
</style>

